import { Component, OnInit, ChangeDetectionStrategy, ChangeDetectorRef, Input } from '@angular/core';
import { VirtualKeyboardService } from './virtual-keyboard.service';

@Component({
  selector: 'i-virtual-keyboard',
  templateUrl: './virtual-keyboard.component.html',
  styleUrls: ['./virtual-keyboard.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class VirtualKeyboardComponent implements OnInit {
  @Input() focusDisabled: boolean = false;
  @Input() blurDisabled: boolean = false;

  visible = false;
  clickable = false;
  key = new Array<string>();

  caps_index = 0;
  shift_index = 0;
  private layout_index = 0;

  constructor(private cdr: ChangeDetectorRef, private virtualKeyboardService: VirtualKeyboardService) {
    this.update();
  }

  ngOnInit() {
    this.virtualKeyboardService.registerKeyboard({
      show: (layout) => {
        if (layout !== null) {
          const newLayoutIndex = layout === 'en' ? 0 : 1;
          if (this.layout_index != newLayoutIndex) {
            this.layout_index = newLayoutIndex;
            this.update();
          }
        }
        this.visible = true;
        this.cdr.markForCheck();
        setTimeout(() => {
          this.clickable = true;
          this.cdr.markForCheck();
        }, 300);
      },
      hide: () => {
        this.visible = false;
        this.clickable = false;
        this.cdr.markForCheck();
      },
      layout: () => {
        this.layout_index = this.layout_index ? 0 : 1;
        this.update();
      },
      shift: () => {
        this.shift_index = this.shift_index ? 0 : 1;
        this.update();
      },
      caps: () => {
        this.caps_index = this.caps_index ? 0 : 1;
        this.update();
      },
      key: () => {
        if (this.shift_index) {
          this.shift_index = 0;
          this.update();
        }
      },
      getNavigationDir: () => !this.shift_index,
      getFocusDisabled: () => this.focusDisabled,
      getBlurDisabled: () => this.blurDisabled,
    });
  }

  private calcValue(data: string): string {
    const dn = this.layout_index ? data[2] : data[0];
    const up = this.layout_index ? data[3] : data[1];
    const r =
      (dn >= 'a' && dn <= 'z') || (dn >= 'а' && dn <= 'я') || dn === 'ё'
        ? this.shift_index === this.caps_index
          ? dn
          : up
        : this.shift_index
        ? up
        : dn;
    return r;
  }

  private update() {
    this.key[0] = 'language';
    this.key[1] = this.calcValue('`~ёЁ');
    this.key[2] = this.calcValue('1!1!');
    this.key[3] = this.calcValue('2@2"');
    this.key[4] = this.calcValue('3#3№');
    this.key[5] = this.calcValue('4$4;');
    this.key[6] = this.calcValue('5%5%');
    this.key[7] = this.calcValue('6^6:');
    this.key[8] = this.calcValue('7&7?');
    this.key[9] = this.calcValue('8*8*');
    this.key[10] = this.calcValue('9(9(');
    this.key[11] = this.calcValue('0)0)');
    this.key[12] = this.calcValue('-_-_');
    this.key[13] = this.calcValue('=+=+');
    this.key[14] = this.calcValue('qQйЙ');
    this.key[15] = this.calcValue('wWцЦ');
    this.key[16] = this.calcValue('eEуУ');
    this.key[17] = this.calcValue('rRкК');
    this.key[18] = this.calcValue('tTеЕ');
    this.key[19] = this.calcValue('yYнН');
    this.key[20] = this.calcValue('uUгГ');
    this.key[21] = this.calcValue('iIшШ');
    this.key[22] = this.calcValue('oOщЩ');
    this.key[23] = this.calcValue('pPзЗ');
    this.key[24] = this.calcValue('[{хХ');
    this.key[25] = this.calcValue(']}ъЪ');
    this.key[26] = this.calcValue('\\|/\\');
    this.key[27] = this.calcValue('aAфФ');
    this.key[28] = this.calcValue('sSыЫ');
    this.key[29] = this.calcValue('dDвВ');
    this.key[30] = this.calcValue('fFаА');
    this.key[31] = this.calcValue('gGпП');
    this.key[32] = this.calcValue('hHрР');
    this.key[33] = this.calcValue('jJоО');
    this.key[34] = this.calcValue('kKлЛ');
    this.key[35] = this.calcValue('lLдД');
    this.key[36] = this.calcValue(';:жЖ');
    this.key[37] = this.calcValue('\'"эЭ');
    this.key[38] = this.calcValue('zZяЯ');
    this.key[39] = this.calcValue('xXчЧ');
    this.key[40] = this.calcValue('cCсС');
    this.key[41] = this.calcValue('vVмМ');
    this.key[42] = this.calcValue('bBиИ');
    this.key[43] = this.calcValue('nNтТ');
    this.key[44] = this.calcValue('mMьЬ');
    this.key[45] = this.calcValue(',<бБ');
    this.key[46] = this.calcValue('.>юЮ');
    this.key[47] = this.calcValue('/?,<');
    this.key[48] = this.calcValue('\u20ac\u00a3.>');
  }
}
